/*
  ============================================================
  SLICK STORE — CENTRAL SALE BADGE TIMER ENGINE
  File: assets/ss-sale-badge.js

  Purpose:
  - Controls ALL .ss-sale-badge badges.
  - Works on product grid and product page.
  - Shows badge only inside ss_sale_start / ss_sale_end.
  - Hides badge before sale starts and after sale ends.

  Important:
  - This file controls timing only.
  - CSS controls design.
  - Liquid only prints hidden badge HTML with date data.
  - Product page countdown timing is separate.
  ============================================================
*/

(function() {
  /*
  ============================================================
  SLICK STORE — SHARED IST DATE WINDOW HELPER
  ============================================================
  Purpose:
  - One IST date parser for the whole site.
  - Used by:
      sale badge engine (this file)
      product page countdown (ss-product-info.liquid)
      announcement bar countdown (ss-announcement-countdown-v5.liquid)
 
  Why:
  - Before this helper, each file had its own copy of the
    same parsing logic. A bug in one didn't get fixed in others.
  - Now all three call SlickSaleWindow.parseIST(str).
 
  Format expected: "DD-MM-YYYY HH:MM" in IST.
  Returns: UTC milliseconds (a Number) if valid, null if not.
 
  Examples:
    parseIST("01-05-2026 00:00")  -> valid IST midnight
    parseIST("31-04-2026 23:59")  -> April has 30 days, returns null
    parseIST("garbage")           -> returns null
    parseIST("")                  -> returns null
 
  Safety:
  - Idempotent: if another script already defined
    window.SlickSaleWindow, we leave it alone.
  ============================================================
*/
if (!window.SlickSaleWindow) {
  window.SlickSaleWindow = (function() {
    var IST_OFFSET = 5.5 * 3600 * 1000;
 
    /*
      Validate that day/month/year/hour/minute is a real date.
      JavaScript Date is forgiving - it would silently roll
      "31-04-2026" into "01-05-2026". We don't want that, so
      we round-trip the values and check they survived intact.
    */
    function isValidDateParts(y, mo, d, h, mi) {
      var dt = new Date(Date.UTC(y, mo - 1, d, h, mi, 0));
      return dt.getUTCFullYear() === y &&
             dt.getUTCMonth()    === mo - 1 &&
             dt.getUTCDate()     === d &&
             dt.getUTCHours()    === h &&
             dt.getUTCMinutes()  === mi;
    }
 
    /*
      Parse "DD-MM-YYYY HH:MM" into UTC milliseconds.
      Returns null if anything is malformed or invalid.
    */
    function parseIST(raw) {
      if (!raw) return null;
 
      // Match the strict format with a regex so weird strings
      // (extra spaces, slashes, missing leading zeros) are rejected.
      var match = String(raw).trim().match(/^(\d{2})-(\d{2})-(\d{4})\s+(\d{2}):(\d{2})$/);
      if (!match) return null;
 
      var dd   = Number(match[1]);
      var mm   = Number(match[2]);
      var yyyy = Number(match[3]);
      var hh   = Number(match[4]);
      var min  = Number(match[5]);
 
      // Basic range check before the expensive round-trip check.
      if (mm < 1 || mm > 12) return null;
      if (dd < 1 || dd > 31) return null;
      if (hh > 23) return null;
      if (min > 59) return null;
 
      // Final validation: does the date actually exist?
      if (!isValidDateParts(yyyy, mm, dd, hh, min)) return null;
 
      // Convert IST to UTC by subtracting 5h30m of milliseconds.
      return Date.UTC(yyyy, mm - 1, dd, hh, min, 0) - IST_OFFSET;
    }
 
    /*
      Convenience: given a start string and end string, return
      a window object describing where "now" sits relative to it.
      Used by the announcement bar and product page countdown.
    */
    function getWindow(startStr, endStr) {
      var startUTC = parseIST(startStr);
      var endUTC   = parseIST(endStr);
 
      // Invalid window if either date is malformed or end <= start.
      if (startUTC === null || endUTC === null || endUTC <= startUTC) {
        return {
          valid:      false,
          startUTC:   null,
          endUTC:     null,
          state:      'invalid',
          msToStart:  0,
          msToEnd:    0
        };
      }
 
      var now = Date.now();
      var state;
 
      if (now < startUTC)      state = 'before';
      else if (now < endUTC)   state = 'active';
      else                     state = 'ended';
 
      return {
        valid:     true,
        startUTC:  startUTC,
        endUTC:    endUTC,
        state:     state,
        msToStart: Math.max(0, startUTC - now),
        msToEnd:   Math.max(0, endUTC - now)
      };
    }
 
    // Public API
    return {
      parseIST:  parseIST,
      getWindow: getWindow
    };
  })();
}

  if (!window.SlickSaleBadgeEngine) {
    window.SlickSaleBadgeEngine = (function() {
      var IST_OFFSET = 5.5 * 3600 * 1000;
      var intervalId = null;

      function readNumber(el, name) {
        return parseInt(el.getAttribute(name), 10);
      }

    

     /*
  Reads the parsed date-parts off a badge element and returns
  UTC milliseconds. Uses the shared helper for the actual
  IST-to-UTC math and validation.
 
  We still read individual data-* attributes (year, month, day,
  hour, minute) because the badge HTML is rendered server-side
  and Liquid already split the date for us. We just reconstruct
  the standard "DD-MM-YYYY HH:MM" string and hand it to the
  shared helper for validation.
*/
function toUtcMs(el, prefix) {
  var y  = readNumber(el, 'data-sale-' + prefix + '-year');
  var mo = readNumber(el, 'data-sale-' + prefix + '-month');
  var d  = readNumber(el, 'data-sale-' + prefix + '-day');
  var h  = readNumber(el, 'data-sale-' + prefix + '-hour');
  var mi = readNumber(el, 'data-sale-' + prefix + '-minute');
 
  // Rebuild the "DD-MM-YYYY HH:MM" string the helper expects.
  // pad() makes sure single-digit numbers get a leading zero.
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  var rebuilt = pad(d) + '-' + pad(mo) + '-' + y + ' ' + pad(h) + ':' + pad(mi);
 
  return window.SlickSaleWindow.parseIST(rebuilt);
}


      function showBadge(el) {
        el.hidden = false;
        el.style.display = '';
        el.classList.add('is-active');
        el.setAttribute('aria-hidden', 'false');
      }

      function hideBadge(el) {
        el.classList.remove('is-active');
        el.setAttribute('aria-hidden', 'true');
        el.hidden = true;
        el.style.display = 'none';
      }

      function updateOne(el) {
        var startUTC = toUtcMs(el, 'start');
        var endUTC = toUtcMs(el, 'end');
        var now = Date.now();

        if (startUTC === null || endUTC === null || endUTC <= startUTC) {
          hideBadge(el);
          return;
        }

        if (now >= startUTC && now < endUTC) {
          showBadge(el);
        } else {
          hideBadge(el);
        }
      }

      function refresh() {
        var badges = document.querySelectorAll('[data-ss-sale-badge]');
        badges.forEach(updateOne);
      }

      function start() {
        refresh();

        if (!intervalId) {
          /*
            Sale dates are minute-level.
            Checking every 30 seconds is enough.
            This also fixes tabs left open before/after sale.
          */
          intervalId = setInterval(refresh, 30000);
        }
      }

      document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
          refresh();
        }
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }

      return {
        refresh: refresh
      };
    })();
  } else {
    window.SlickSaleBadgeEngine.refresh();
  }
})();